import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AuthLayoutComponent, LoginPageComponent } from './pages';
import { LoginFormComponent } from './components';

const pages = [AuthLayoutComponent, LoginPageComponent];
const components = [LoginFormComponent];

const routes: Routes = [{
  path: '', component: AuthLayoutComponent, children: [
    { path: 'login', component: LoginPageComponent }
  ]
}];

@NgModule({
  declarations: [...pages, ...components],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AngularSvgIconModule, RouterLink, RouterModule.forChild(routes)]
})
export class AuthModule {
}
